export default __webpack_public_path__ + "static/house-5fe9f785f4aa04916f989b738b54f26f.mp4";